module.exports = __webpack_public_path__ + "static/media/album.0ea269f0.jpg";